goog.provide('el8.ptdata.pharmacyPrescriptionRequests');

goog.require('el8.model.base');
goog.require('el8.data.medications');
goog.require('el8.data.pharmacies');
goog.require('el8.ptdata.denialMedOrders');
goog.require('el8.ptdata.model.med.medOrder');
goog.require('el8.util.base');
goog.require('el8.ptdata.model.pharmacyPrescription');


el8.ptdata.pharmacyPrescriptionRequests = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makeHoldable();
    _class.makeDocument();

    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);

        if (spec.prescription_prescribed) {
          this.setPrescriptionPrescribed(
            el8.ptdata.model.pharmacyPrescription(spec.prescription_prescribed)
          )
        }

        if (spec.prescription_requested) {
          this.setPrescriptionRequested(
            el8.ptdata.model.pharmacyPrescription(spec.prescription_requested)
          );
        }

        if (spec.pharmacy) {
          this.setPharmacy(spec.pharmacy);
        }

        if (spec.original_med_order) {
            this.setOriginalMedOrder(el8.ptdata.model.med.medOrder(spec.original_med_order));
        }
    };

    _class.addStringProperty('changeRequestType');
    _class.addProperty('originalMedOrder');
    _class.addProperty('pharmacy');
    _class.addStringProperty('pharmacistName');
    _class.addIntProperty('prescriberId');
    _class.addStringProperty('prescriberName');
    _class.addProperty('prescriptionPrescribed');
    _class.addProperty('prescriptionRequested');
    _class.addStringProperty('requestType');
    _class.addStringProperty('response');
    _class.addStringProperty('responseReason');
    _class.addIntProperty('followupNumber');

    // for prior auth requests
    _class.addStringProperty('payerName');
    _class.addStringProperty('priorAuthNum');
    _class.addStringProperty('reasonCode');



    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); }
    });

    _class.prototype.getHumanReadableChangeRequestType = function() {
      switch (this.getChangeRequestType()) {
        case 'G':
          return 'Generic Substitution “G”';

        case 'P':
          return 'Prior Authorization Required “P”';

        case 'T':
          return 'Therapeutic Interchange/Substitution “T”';

        case 'D':
          return 'DUE - Drug Use Evaluation “D”';

        case 'S':
          return 'Script Clarification “S”';

        case 'OS':
          return 'Out of Stock “OS”';

        default:
          return 'Unknown change request type'
      }
    }

    return that;
})();
